import { Button, Input, Popover } from "@salesforce/design-system-react";
import debounce from "lodash.debounce";
import { useEffect, useState } from "react";
import { FolderMetadata } from "vimeo";
import { AvatarMenu } from "./AvatarMenu";
import { Folders } from "./Folders";

interface Props {
    onFolderSelected: (uri: string, metadata?: FolderMetadata) => void;
    onSearchChange: (event: KeyboardEvent, value: any) => void;
    numRootFolderVideos: number;
}

export function ContentBlockHeader(props: Props) {
    const [numVideos, setNumVideos] = useState(0);
    const path = window.location.pathname;

    const { numRootFolderVideos } = props;

    useEffect(() => {
        setNumVideos(numRootFolderVideos);
    }, [numRootFolderVideos]);

    return (
        <header className="slds-global-header_container">
            <div className="slds-global-header slds-grid slds-grid_align-spread">
                <div
                    className="slds-global-header__item"
                    style={{ display: "flex" }}
                >
                    <Folders
                        folderSelected={(uri, folderMetadata) => {
                            setNumVideos(
                                folderMetadata?.connections.videos.total || 0
                            );
                            props.onFolderSelected(uri, folderMetadata);
                        }}
                        width="xx-small"
                    />
                    <span
                        style={{
                            color: "#9D9D9D",
                            marginTop: "0.275rem",
                            marginLeft: "0.5rem",
                        }}
                    >
                        {numVideos} items
                    </span>
                </div>
                <div className="slds-global-header__item">
                    <ul className="slds-global-actions">
                        <li className="slds-global-actions__item">
                            <a
                                href="https://vimeo.com/upload/videos"
                                target="_blank"
                                className="slds-button slds-button_base"
                                rel="noreferrer"
                            >
                                Upload
                            </a>
                        </li>
                        <li className="slds-global-actions__item">
                            <Popover
                                align="bottom"
                                variant="base"
                                hasNoNubbin={true}
                                position="overflowBoundaryElement"
                                heading="Search for videos"
                                body={
                                    <Input
                                        id="videoSearchInput"
                                        type="search"
                                        onChange={debounce(
                                            props.onSearchChange,
                                            250
                                        )}
                                        iconLeft=""
                                        iconRight=""
                                        placeholder="Start typing to search for videos..."
                                    />
                                }
                            >
                                <Button
                                    assistiveText={{ icon: "Search button" }}
                                    iconCategory="utility"
                                    iconName="search"
                                    iconSize="small"
                                    iconVariant="container"
                                    variant="icon"
                                />
                            </Popover>
                        </li>
                        <li className="slds-global-actions__item">
                            <AvatarMenu postLogoutRedirectUrl={path} />
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
}
